module.exports = __webpack_public_path__ + "static/media/KOM_04.99829a52.png";